import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-ussd-simulator',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './ussd-simulator.component.html',
  styleUrl: './ussd-simulator.component.css',
})
export class UssdSimulatorComponent {}
